export const STORAGE_KEYS = {
  AUTH_TOKEN: 'authToken',
  PENDING_USER: 'pendingUser',
  VERIFIED_EMAIL: 'verifiedEmail',
  FORGOT_PASSWORD_EMAIL: 'forgotPasswordEmail'
};

export const API_ENDPOINTS = {
  LOGIN: '/login',
  REGISTER: '/registration',
  VERIFY_OTP: '/verify-otp',
  RESEND_OTP: '/resend-otp',
  CREATE_PASSWORD: '/create-password',
  FORGOT_PASSWORD: '/forgot-password',
  SAVE_LEGACY_CONTACT: '/save-legacy-contact',
  GET_PROFILE: '/profile',
  GET_SUBSCRIPTION_PLANS: '/get-subscriptionplans',
  VALIDATE_PROMO_CODE: '/validate-promo-code',
  CREATE_SUBSCRIPTION: '/create-subscription',
  SAVE_HOW_HEARD_ABOUT_US: '/save-HowHeardAboutUs'
};



export const VALIDATION_MESSAGES = {
  REQUIRED: 'This field is required',
  EMAIL_INVALID: 'Please enter a valid email address',
  PASSWORD_WEAK: 'Password must include',
  PASSWORDS_NO_MATCH: 'Passwords do not match',
  PHONE_INVALID: 'Phone number must be exactly 10 digits',
  NAME_INVALID: 'Only letters and spaces are allowed'
};

export const REGEX_PATTERNS = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE: /^\d{10}$/,
  NAME: /^[a-zA-Z\s]+$/,
  SINGLE_SPACE: /^\S+(?: \S+)*$/,
  PASSWORD: {
    UPPERCASE: /[A-Z]/,
    LOWERCASE: /[a-z]/,
    DIGIT: /[0-9]/,
    SPECIAL: /[!@#$%^&*(),.?":{}|<>]/
  }
};